export const environment = {
    production: true,
    server: "https://wsempower.gosmartcrm.com:4500/ws",
    firebase: {
        apiKey: "AIzaSyDNMCAq3xiYB8LopS4TAYtUL-R-SEj97OI",
        authDomain: "empowerinsurance-e6ee5.firebaseapp.com",
        projectId: "empowerinsurance-e6ee5",
        storageBucket: "empowerinsurance-e6ee5.appspot.com",
        messagingSenderId: "476237772871",
        appId: "1:476237772871:web:33b0c6fd2228a0066a1962",
        measurementId: "G-3MGQRPZY58",
    },
};
